/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Page_PainInputs */

const en_us2_profile_page_pain = /** @type {(inputs: Profile_Page_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Health`)
};

const pt_br2_profile_page_pain = /** @type {(inputs: Profile_Page_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saúde`)
};

const es_419_profile_page_pain = /** @type {(inputs: Profile_Page_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salud`)
};

const pt_pt2_profile_page_pain = /** @type {(inputs: Profile_Page_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saúde`)
};

const fr_fr2_profile_page_pain = /** @type {(inputs: Profile_Page_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Santé`)
};

const de_de2_profile_page_pain = /** @type {(inputs: Profile_Page_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesundheit`)
};

const it_it2_profile_page_pain = /** @type {(inputs: Profile_Page_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salute`)
};

/**
* | output |
* | --- |
* | "Health" |
*
* @param {Profile_Page_PainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_page_pain = /** @type {((inputs?: Profile_Page_PainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Page_PainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_page_pain(inputs)
	if (locale === "es-419") return es_419_profile_page_pain(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_page_pain(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_page_pain(inputs)
	if (locale === "de-DE") return de_de2_profile_page_pain(inputs)
	if (locale === "it-IT") return it_it2_profile_page_pain(inputs)
	return en_us2_profile_page_pain(inputs)
});
export { profile_page_pain as "profile.page_pain" }